import { Selector } from "@ngxs/store";
import { ExtractState, ExtractStateModel, QueriesState, QueriesStateModel, QueryState, QueryStateModel } from "./extract.state";

export class ExtractGetterState {
  @Selector([ExtractState])
  static getPreviewData(state: ExtractStateModel) {
    return state.previewData;
  }

  @Selector([ExtractState])
  static getPreviewIsLoading(state: ExtractStateModel) {
    return state.previewIsLoading;
  }

  @Selector([ExtractState])
  static getDownloadIsLoading(state: ExtractStateModel) {
    return state.downloadIsLoading;
  }

  @Selector([ExtractState])
  static getLoadingMessage(state: ExtractStateModel) {
    return state.loadingMessage || 'Sending request to the server ...';
  }

  @Selector([ExtractState])
  static getExtractUrl(state: ExtractStateModel) {
    return state.extractUrl;
  }

  @Selector([ExtractState])
  static getExtractName(state: ExtractStateModel) {
    return state.extractName;
  }
}

export class QueriesGetterState {
  @Selector([QueriesState])
  static getQueries(state: QueriesStateModel) {
    return state.queries;
  }
}

export class QueryGetterState {
  @Selector([QueryState])
  static getQuery(state: QueryStateModel) {
    return state;
  }
}